import ReactDom from 'react-dom';

import { useQuery } from 'react-query';

import { getUpdateRaw } from '@services/queries/updates';
import { Overlay, Container } from './DetailsDialog.styles';

import { DetailsDialogRaw } from './DetailsDialog.raw';
import { DetailsDialogLoading } from './DetailsDialog.loading';

interface IDetailsDialog {
  open: boolean;
  onClose: () => void;
  updateId: string;
}

export const DetailsDialog = ({ open, onClose, updateId }: IDetailsDialog) => {
  const portalDiv = document.getElementById('portal');

  const {
    data: updateStatus,
    isLoading,
    isError,
  } = useQuery(['updateStatuses', updateId], () => getUpdateRaw(updateId));

  if (!updateId) {
    return <div />;
  }

  return open && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            {isLoading && <DetailsDialogLoading />}
            {(isError || !updateStatus) && !isLoading && <>error</>}

            {updateStatus && (
              <DetailsDialogRaw updateStatus={updateStatus} onClose={onClose} />
            )}
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};
